import { Breadcrumb, Product } from "@/types/types";

export const FitFinderListenerEvents = {
  available: "fit-analytics-product-load",
  opened: "open-fit-analytics",
  sizeRecommended: "fit-analytics-size-recommended",
  immediateRecommendation: "fit-analytics-immediate-recommendation",
  initialRecommendation: "fit-analytics-initial-recommendation",
};

export const FitFinderImpressions = {
  available: "pdp-scaffold-fit-finder-available",
  opened: "pdp-scaffold-fit-finder-opened",
};

export const FitFinderClickEvents = {
  available: "pdp:fitfinder:button:available",
  opened: "pdp:fitfinder:button:click",
  sizeRecommended: "pdp:fitfinder:size-recommended",
  immediateRecommendation: "pdp:fitfinder:immediate-recommendation",
  initialRecommendation: "pdp:fitfinder:initial-recommendation",
};

export const includedCategories = [
  {
    url: "/women/c50000298",
    name: "Women",
  },
  {
    url: "/men/c50000300",
    name: "Men",
  },
];

export const getBreadCrumbs = (product: Product) => {
  const breadCrumbs = product.browsePageHierarchy.map((browsePage) => {
    return {
      clickable: 1,
      value: browsePage.name?.toLowerCase(),
      url: "url" in browsePage ? browsePage.url : "",
    };
  });

  breadCrumbs.shift();
  return breadCrumbs;
};

type FeatureCategory = {
  name: string;
  url: string;
};

export const normalizeImageUrl = (url: string | null): string => {
  if (!url) {
    return "";
  }
  const trimmedUrl = url.trim();
  return trimmedUrl.indexOf("?") > -1 ? trimmedUrl : trimmedUrl + "?";
};

export const isFeatureEnabledForCategory = (
  breadCrumbs: Breadcrumb[] = [],
  featureCategories: FeatureCategory[] = [],
) => {
  const includedHash = getHash(featureCategories, "url");

  return breadCrumbs.some((crumb) => includedHash[crumb.url]);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getHash<T extends { [key: string]: any }>(
  data: T[],
  key: string,
): Hash {
  return data.reduce((acc: Hash, item) => ({ ...acc, [item[key]]: true }), {});
}

interface Hash {
  [key: string]: boolean;
}
